import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 24;

@Component({
  selector: 'app-document-icon',
  standalone: true,
  templateUrl: './document-icon.component.html'
})
export class DocumentIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
